import React from 'react';
import styled from 'styled-components';
import googlePlayBadge from '../assets/images/stores/GetItOnGooglePlay.png';
import appStoreBadge from '../assets/images/stores/GetItOnAppleStore.png';

type StoreName = 'google-play' | 'apple';

interface StoreBadgeLinkProps {
  store: StoreName;
  href: string;
  label: string;
}

const BADGES: Record<StoreName, string> = {
  'google-play': googlePlayBadge,
  apple: appStoreBadge,
};

const BadgeAnchor = styled.a`
  display: inline-flex;
  transition: transform 0.2s ease;

  &:hover,
  &:focus {
    transform: translateY(-2px);
  }
`;

/* The badge PNGs carry uneven transparent margins (≈12px left/bottom, ≈6px right,
   ≈3px top at this size). Negative margins trim the layout box to the visible
   badge so it centers exactly inside its container. */
const BadgeImage = styled.img`
  height: 82px;
  width: auto;
  display: block;
  border-radius: 12px;
  margin: -3.5px -6.4px -12px -12px;
`;

const StoreBadgeLink: React.FC<StoreBadgeLinkProps> = ({ store, href, label }) => (
  <BadgeAnchor href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
    <BadgeImage src={BADGES[store]} alt={label} />
  </BadgeAnchor>
);

export default StoreBadgeLink;
